export default (currentPrice: number | undefined, oldPrice?: number | null): string | null => {
  if (!currentPrice || !oldPrice || oldPrice < currentPrice) {
    return null
  }

  const discountPercentage = Math.floor(100 - (currentPrice * 100) / oldPrice)

  if (discountPercentage < 1) {
    return null
  }

  const prefix = '-'

  return `${prefix}${discountPercentage} %`
}
